/**
 * @description 调用二维码
 * @date 2019-8-13
 * @author txw
 */
import Vue from 'vue'
import { Dialog } from 'vant'
Vue.use(Dialog)
// 判断移动端系统
let browser = {
  versions: (function () {
    let u = navigator.userAgent
    // let app = navigator.appVersion
    return { // 移动终端浏览器版本信息
      trident: u.indexOf('Trident') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或uc浏览器
      iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, // 是否iPad
      webApp: u.indexOf('Safari') === -1 // 是否web应该程序，没有头部与底部
    }
  }()),
  isweixin: (function () {
    let ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) === 'micromessenger') { // 判断是否在微信中打开
      return true
    } else {
      return false
    }
  }()),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}
const downloadDialog = {
  message: '下载APP才可以使用此功能？',
  cancelButtonText: '我知道了',
  confirmButtonText: '马上下载',
  beforeClose (action, done) {
    if (action === 'confirm') {
      window.location = '/appdown.html'
    } else {
      done()
    }
  }
}

export function wxshared () {
  if (!browser.versions.android) {
    connectWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler('wxsharedcode', function (data, responseCallback) {
        console.log('ObjC called scancode with', data)
        let responseData = { 'Javascript Says': 'Right back atcha!' }
        console.log('JS responding with', responseData)
        responseCallback(responseData)
      })
      bridge.callHandler('wxsharedcode')
    })
  }
}
// 判断app是否在微信和ios中打开，如果不是则调用二维码扫描
export function scanning (obj) {
  // let download = $(obj).siblings(".download").val();
  if (browser.versions.android) {
    if (browser.isweixin) {
      Dialog.confirm(downloadDialog)
    } else {
      window.TWAPI.scancode()
    }
  } else {
    if (browser.isweixin) {
      Dialog.confirm(downloadDialog)
    } else if (browser.webApp) {
      Dialog.confirm(downloadDialog)
    } else {
      window.onerror = function (err) {
        console.log('window.onerror: ' + err)
      }
      setupWebViewJavascriptBridge(function (bridge) {
        bridge.registerHandler('scancode', function (data, responseCallback) {
          console.log('ObjC called scancode with', data)
          let responseData = { 'Javascript Says': 'Right back atcha!' }
          console.log('JS responding with', responseData)
          responseCallback(responseData)
        })
        bridge.callHandler('scancode')
      })
    }
  }
}
function connectWebViewJavascriptBridge (callback) {
  if (!browser.versions.android) {
    if (window.WebViewJavascriptBridge) {
      callback(window.WebViewJavascriptBridge)
    } else {
      document.addEventListener('WebViewJavascriptBridgeReady', function () {
        callback(window.WebViewJavascriptBridge)
      }, false)
    }
  }
}
function setupWebViewJavascriptBridge (callback) {
  if (window.WebViewJavascriptBridge) { return callback(window.WebViewJavascriptBridge) }
  if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback) }
  window.WVJBCallbacks = [callback]
  let WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(function () { document.documentElement.removeChild(WVJBIframe) }, 0)
}
